import {
  MDBBtn,
  MDBDatatable,
  MDBIcon,
  MDBTable,
  MDBTableBody,
  MDBTableHead,
} from "mdb-react-ui-kit";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import PopupLoader from "../../../views/popups/PopupLoader";
import AddToGroup from "../../../views/popups/users/AddToGroup";
import { editUser, getMisc } from "../../../apiclients/streamsapi_bridge";
import DeleteGroup from "../../../views/popups/users/DeleteGroup";
import { useFieldArray } from "react-hook-form";
import ToggleEditWarning from "../hunt/ToggleEditWarning";
import ULMGroupWarning from "./ULMGroupWarning";
const UserGroup = ({
  useragent,
  usergroups,
  register,
  getValues,
  setValue,
  setSuccessMessage,
  setErrorMessage,
  ulmGroupList,
  watch,
  control,
  reset,
  allowULMGroup,
  errors,
  setRerender,
  isstreamsReq
}) => {
  const { t, i18n } = useTranslation();
  const [addGroup, setAddGroup] = useState(false);
  const toggleGroup = () => setAddGroup(!addGroup);
  const [agentid, setAgentID] = useState("");
  const [groupswithdelete, setGroupsWithDelete] = useState([]);
  const [selectedGroups, setSelectedGroups] = useState([]);
  const [updateGroups, setUpdateGroups] = useState([]);
  const [userAddedGroups, setUserAddedGroups] = useState([]);
  const [removedGroups, setRemovedGroups] = useState([]);
  const [updateGroupsExecuted, setUpdateGroupsExecuted] = useState(false);
  const [deleteGroupFlag, setdeleteGroupFlag] = useState(false);
  const [finaladdlist, setFinalAddList] = useState([]);
  const [finalremovedlist, setFinalRemovedList] = useState([]);
  const [freeGroupflag, setFreeGroupFlag] = useState(true);
  const [sourceGroups, setSourceGroups] = useState([]);
  const [isdeleteGroup, setIsDeleteGroup] = useState(false);
  const dtogglePopup = () => setIsDeleteGroup(!isdeleteGroup);
  const [selectedOption, setSelectedOption] = useState("-1");
  const [editWarning, seteditWarning] = useState(false);
  const warningToggle = () => seteditWarning(!editWarning);
  const [ulmWarning, setulmWarning] = useState(false);
  const ulmwarningToggle = () => setulmWarning(!ulmWarning);
  const [updateFieldName, setupdateFieldName] = useState("");
  const [updateFieldValue, setupdateFieldValue] = useState("");
  const [toggleValue, settoggleValue] = useState(-1);
  const [indexNumber, setindexNumber] = useState(-1);

  const { fields } = useFieldArray({
    control,
    name: "ulm_groups.groups",
  });

  useEffect(() => {
    if (ulmGroupList.length > 0) {
      // debugger;
      // reset((prev) => ({
      //   ...prev,
      //   ulm_groups: { ...prev.ulm_groups, groups: ulmGroupList },
      // }));
      setValue("ulm_groups.groups", ulmGroupList, { shouldDirty: false });
    }
  }, [ulmGroupList]);

  const handleDelete = (event, infoObj) => {
    event.preventDefault();
    dtogglePopup();
    setUpdateGroups([infoObj]);
  };

  useEffect(() => {
    async function fetchData() {
      let groupList = [];
      let apiResponse = await getMisc(
        JSON.parse(sessionStorage.getItem("admin_session")).siteid,
        { misc: ["groups"], agentid: useragent }
      );
      if (apiResponse.status === 200) {
        groupList = await apiResponse.json();
        groupList = groupList.misc.groups;
        //alert(JSON.stringify(groupList));
        setSourceGroups(groupList);
      } else {
        // Unable to process the request case.
      }
      setFreeGroupFlag(false);
    }

    if (useragent && freeGroupflag) {
      fetchData();
    }
  }, [useragent, freeGroupflag]);

  useEffect(() => {
    if (useragent) {
      setAgentID(useragent);
      frameGroupDetails(usergroups);
      setSelectedGroups(usergroups);
    }
  }, [useragent]);

  async function addGroups(fieldName) {
    const addcodeList = new Set(updateGroups.map((item) => item.code));
    const addtitleList = new Set(updateGroups.map((item) => item.title));
    let update = {
      reqid: 3,
      siteid: JSON.parse(sessionStorage.getItem("admin_session")).siteid,
      agentid: useragent,
      groups: {
        [fieldName]: Array.from(addcodeList),
      },
      logined_user: JSON.parse(sessionStorage.getItem("admin_session"))
        .logined_user,
    };

    console.log(JSON.stringify(update));
    let saverep = await editUser(update);
    console.log(saverep);
    let saverepeMsg = await saverep.json();
    if (saverepeMsg.status && saverepeMsg.status == "success") {
      if (fieldName === "added_groups") {
        const modifygrp = [...selectedGroups, ...updateGroups];
        setSelectedGroups(modifygrp);
        frameGroupDetails(modifygrp);
        setRerender(true)
        setSuccessMessage(
          `Group(s) ${Array.from(addtitleList)} added successfully.`
        );
      } else {
        const updategroup = selectedGroups.filter((item1) =>
          updateGroups.some((item2) => item2.code !== item1.code)
        );
        setSelectedGroups(updategroup);
        frameGroupDetails(updategroup);
        setRerender(true)
        setSuccessMessage(
          `Group(s) ${Array.from(addtitleList)} removed successfully.`
        );
      }
    } else {
      if (fieldName === "removed_groups") {
        const modifynum = selectedGroups.filter((item1) =>
          updateGroups.some((item2) => item2.code !== item1.code)
        );
        setSelectedGroups([...modifynum, ...updateGroups]);
      }
      if (saverepeMsg.message?.errors) {
        saverepeMsg.message.errors.forEach((err) => {
          if (err.param_name === "logined_user") {
            setErrorMessage(err.message);
          }
          const fieldElement = document.querySelector(
            `input[name="${err.param_name}"]`
          );
          if (fieldElement) {
            fieldElement.focus();
            fieldElement.scrollIntoView({ behavior: "smooth" });
          }
        });
      }
    }
  }

  useEffect(() => {
    if (updateGroups.length > 0 && updateGroupsExecuted) {
      addGroups("added_groups");
      setUpdateGroupsExecuted(false);
    }
  }, [updateGroups, updateGroupsExecuted]);

  useEffect(() => {
    if (updateGroups.length > 0 && deleteGroupFlag) {
      addGroups("removed_groups");
      setdeleteGroupFlag(false);
    }
  }, [updateGroups, deleteGroupFlag]);

  function frameGroupDetails(groupInfo) {
    let proccessdRows = [];
    //alert(JSON.stringify(groupInfo));
    groupInfo?.forEach((infoObj) => {
      // debugger;
      let processedRow = {
        title: infoObj.title,
        type:
          infoObj?.type !== undefined
            ? infoObj.type === 1
              ? "ACD"
              : infoObj.type === 0
                ? "Hunt"
                : "--"
            : "--",
        role:
          infoObj.role !== undefined ? (
            <>{infoObj.role ? infoObj.role : "User"}</>
          ) : (
            "--"
          ),
        ...(!isstreamsReq && {

          delete: (
            // <i
            //   className="fas fa-xmark ms-3 text-primary cursor-pointer"
            //   href="#"
            //   onClick={(e) => handleDelete(e, infoObj)}
            //   //defaultValue={infoObj.agentid}
            //   target="_new"
            // />
            <div className="d-flex align-items-center ms-2">
              <div
                className="custom-hover-bg p-1 cursor-pointer deleteToolTip"
                onClick={(e) => handleDelete(e, infoObj)}
              >
                <MDBIcon fas icon="times" color="primary" className="mx-2 fs-5" />
              </div>
            </div>
          )
        }),
      };
      proccessdRows.push(processedRow);
    });
    setGroupsWithDelete(proccessdRows);
  }
  let columnsInfo = [
    { label: "Name", field: "title" },
    { label: "Type", field: "type" },
    { label: "Role(s)", field: "role" },
    ...(!isstreamsReq ? [{ label: "Remove", field: "delete", sort: false }] : [])
  ];

  const [isChecked, setIsChecked] = useState(false);

  const handleCheckboxChange = () => {
    setIsChecked(!isChecked);
  };

  // useEffect(() => {
  //   setSelectedOption("-1");

  // }, [])

  const handleFieldChange = (e, index) => {
    setValue(`ulm_groups.groups[${index}].value`, e.target.checked, {
      shouldDirty: true,
    });
    if (
      e.target.checked &&
      !watch("ulm_groups.includeinucc") &&
      !watch("ulm_groups.independentulm")
    ) {
      setulmWarning(true);
      setindexNumber(index);
    }
  };

  let rowData = [];
  fields &&
    fields.length > 0 &&
    fields.forEach((infoObj, index) => {
      rowData.push({
        name: (
          <>
            {infoObj.privilage && [2, 4].includes(infoObj.privilage) ? (
              <strong>{`${infoObj.title} ${infoObj.titleExt}`}</strong>
            ) : (
              infoObj.title + " " + infoObj.titleExt
            )}
          </>
        ),
        value: (
          <>
            <center>
              <label className="switch">
                <input
                  className="form-control"
                  type="checkbox"
                  checked={watch(`ulm_groups.groups[${index}].value`)}
                  value={watch(`ulm_groups.groups[${index}].value`)}
                  onChange={(e) => {
                    handleFieldChange(e, index);
                    // setValue(`ulm_groups.groups[${index}].code`, infoObj.code, {
                    //   shouldDirty: true,
                    // });
                  }}
                />
                <span className="slider round"></span>
              </label>
            </center>
          </>
        ),
      });
    });

  function handleUpdateToggle() {
    fields && fields.forEach((obj, index) => {
      if (
        watch(`ulm_groups.groups[${index}].${updateFieldName}`) !== undefined
      ) {
        setValue(
          `ulm_groups.groups[${index}].${updateFieldName}`,
          updateFieldValue,
          {
            shouldDirty: true,
          }
        );
        // setValue(`ulm_groups.groups[${index}].code`, obj.code, {
        //   shouldDirty: true,
        // });
      }
    });
    setSelectedOption("-1");
    warningToggle();
  }

  function handleCloseWarning() {
    setSelectedOption("-1");
    warningToggle();
  }
  function handleOkWarning() {
    if (indexNumber !== -1) {
      setindexNumber(-1);
      setValue(`ulm_groups.groups[${indexNumber}].value`, false, {
        shouldDirty: true,
      });
    }
    setSelectedOption("-1");
    ulmwarningToggle();
  }

  const updateToggles = (e, fieldName, value) => {
    if (value !== "-1") {
      if (
        value &&
        !watch("ulm_groups.includeinucc") &&
        !watch("ulm_groups.independentulm")
      ) {
        setulmWarning(true);
        return;
      }
      setupdateFieldName(fieldName);
      setupdateFieldValue(value);
      seteditWarning(true);
      settoggleValue(value);
    }
  };

  const actionData = {
    columns: [
      {
        label: (
          <>
            <p className="fw-bold">Unified Live Monitor</p>
            <p>&nbsp;</p>
          </>
        ),
        field: "name",
        sort: false,
      },
      {
        label: (
          <>
            <p className="fw-bold text-center">Show All / Hide All</p>
            <center>

              <div className="three-checkbox round2 mx-0">
                <input
                  type="radio"
                  name="showAll"
                  checked={selectedOption === false}
                  onChange={(e) => {
                    setSelectedOption(false);
                    updateToggles(e, "value", false);
                  }}
                />
                <input
                  type="radio"
                  name="showAll"
                  checked={selectedOption === "-1"}
                  onChange={(e) => {
                    setSelectedOption("-1");
                    updateToggles(e, "value", "-1");
                  }}
                />
                <input
                  type="radio"
                  name="showAll"
                  checked={selectedOption === true}
                  onChange={(e) => {
                    setSelectedOption(true);
                    updateToggles(e, "value", true);
                  }}
                />
                <span className="slider"></span>
              </div>
            </center>
          </>
        ),
        field: "value",
        sort: false,
      },
    ],
    rows: rowData,
  };

  return (
    <>
      <div className="add-numbermain noHoverBg align-items-center mb-3">
        <div className="general-settings mb-0 ps-0" id="Groups">
          {t("Groups")}
        </div>
        {!isstreamsReq && (
          <MDBBtn
            onClick={(e) => {
              e.preventDefault();
              toggleGroup();
            }}
          >
            <MDBIcon fas icon="plus" size="sm" /> {t("AddtoGroup")}
          </MDBBtn>
        )}
      </div>
      <div className="ps-0 userEdit_GroupsTable">

        <MDBDatatable
          // search
          entries={50}
          maxHeight="63vh"
          sortOrder="asc"
          sortField="Name"
          searchInputProps={[]}
          data={{
            columns: columnsInfo,
            rows: groupswithdelete,
          }}
          hover
        />
      </div>

      {allowULMGroup && (
        <>
          <div class="fw-bold pt-3" style={{ paddingLeft: "10px" }}>ULM Groups Visibility Settings</div>

          <div className="add-numbermain">
            <div className="tel-numbers">{t("ULMAccess")}</div>
            <div
              {...(isstreamsReq
                ? {
                  title:
                    "User does not have permission to edit",
                  className: "disabled-form cursor-notAllowed",
                  onClick: (e) => {
                    e.preventDefault();
                    e.stopPropagation();
                  },
                }
                : {})}
            >
              <div className="phoneselect">
                <label className="switch">
                  <input
                    // onChange={handleCheckboxChange}
                    // checked={isChecked}
                    {...register("ulm_groups.ulmaccess")}
                    className="form-control"
                    type="checkbox"
                  />
                  <span className="slider round"></span>
                </label>
              </div>
            </div>
          </div>

          {watch("ulm_groups.ulmaccess") && (
            <>
              <div className="add-numbermain">
                <div className="tel-numbers">Include in UCC</div>
                <div className="phoneselect">
                  <label className="switch">
                    <input
                      className="form-control"
                      type="checkbox"
                      {...register("ulm_groups.includeinucc")}
                    />

                    <span className="slider round"></span>
                  </label>
                  {errors?.ulm_groups?.includeinucc && (
                    <p className="text-danger">
                      {errors?.ulm_groups?.includeinucc?.message}
                    </p>
                  )}
                </div>
              </div>

              {/* <div className="add-numbermain">
            <div className="tel-numbers">
              Include in Independent Unified Live Monitor
            </div>
            <div className="phoneselect">
              <label className="switch">
                <input
                  className="form-control"
                  type="checkbox"
                  {...register("ulm_groups.independentulm")}
                />
                <span className="slider round"></span>
              </label>
            </div>
          </div> */}

              {/* <div class="fw-bold py-3">Unified Live Monitor</div> */}

              <MDBDatatable pagination={false} hover data={actionData} />
              <div className="mt-4">
                <strong>Note: '*' </strong>Indicates that the user has
                Supervisor privileges for that respective group. Group displayed
                in <strong>BOLD </strong>font indicates that the user is not
                part of that respective group but having Monitoring/Supervisor
                privileges.
              </div>
            </>
          )}
        </>
      )}

      {addGroup && (
        <PopupLoader
          // size="lg"
          // className="modal-lg"
          title={t("AddtoGroup")}
          content={
            <AddToGroup
              agentid={agentid}
              selectedGroups={selectedGroups}
              setUpdateGroups={setUpdateGroups}
              setUpdateGroupsExecuted={setUpdateGroupsExecuted}
              sourceGroups={sourceGroups}
              onClose={toggleGroup}
            />
          }
          onShow={setAddGroup}
          onClose={toggleGroup}
        />
      )}

      {isdeleteGroup && (
        <PopupLoader
          title={"Remove Group"}
          content={
            <DeleteGroup
              onClose={dtogglePopup}
              setdeleteGroupFlag={setdeleteGroupFlag}
            />
          }
          onShow={setIsDeleteGroup}
          onClose={dtogglePopup}
        />
      )}
      {editWarning && (
        <PopupLoader
          size="md"
          title="Warning"
          content={
            <ToggleEditWarning
              handleUpdateToggle={handleUpdateToggle}
              handleCloseWarning={handleCloseWarning}
              toggleValue={toggleValue}
              columnName="Show All/Hide All"
            />
          }
          onShow={seteditWarning}
          onClose={handleCloseWarning}
        />
      )}
      {ulmWarning && (
        <PopupLoader
          size="md"
          title="Warning"
          content={<ULMGroupWarning onClose={handleOkWarning} />}
          onShow={setulmWarning}
          onClose={ulmwarningToggle}
        />
      )}
    </>
  );
};
export default UserGroup;
